import Tooltip from "@mui/material/Tooltip";
import "./LangaugeComponent.scss";
import { useAppSelector } from "../../store/hooks";
import Box from "@mui/material/Box";

interface enabledLanguage {
  languageName: string;
  languageCode: string;
  active: boolean;
}

interface LanguageComponentProps {
  enabledLanguages: enabledLanguage[];
}

const LanguageComponent: React.FC<LanguageComponentProps> = ({
  enabledLanguages,
}) => {
  return (
    <div className="toggle-container">
      {enabledLanguages.map((row, index) => (
        <div
          key={index}
          className={`toggle-option ${row.active ? "selected" : "unselected"}`}
        >
          <Tooltip title={`${row.languageName}`} arrow>
            <Box sx={{ textTransform: "uppercase" }}> {row.languageCode} </Box>
          </Tooltip>
        </div>
      ))}
    </div>
  );
};

export default LanguageComponent;
